import { render, staticRenderFns } from "./vpd-transactions.vue?vue&type=template&id=46bcc2da"
import script from "./vpd-transactions.vue?vue&type=script&lang=js"
export * from "./vpd-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports